import React, {Component} from 'react';
//import { Alert } from 'reactstrap';
import {withRouter} from 'react-router-dom';
import auth0Client from '../Auth';
import axios from 'axios';
import {ToastContainer, ToastStore} from 'react-toasts';
import {SERVER_URL, LOCAL_URL} from '../Constants';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Multiselect } from 'multiselect-react-dropdown';
var momenttz = require('moment-timezone');

const restrictedTokens= [
  'usps_priority','usps_priority_express','usps_first','usps_parcel_select','usps_media_mail','usps_priority_mail_international','usps_priority_mail_express_international','usps_first_class_package_international_service',
'fedex_ground',
'fedex_home_delivery',
'fedex_smart_post',
'fedex_2_day',
'fedex_2_day_am',
'fedex_express_saver',
'fedex_standard_overnight',
'fedex_priority_overnight',
'fedex_first_overnight',
'fedex_freight_priority',
'fedex_next_day_freight',
'fedex_freight_economy',
'fedex_first_freight',
'fedex_international_economy',
'fedex_international_priority',
'fedex_international_first',
'fedex_europe_first_international_priority',
'fedex_international_connect_plus',
'international_economy_freight',
'international_priority_freight',
'ups_standard',
'ups_ground',
'ups_saver',
'ups_3_day_select',
'ups_second_day_air',
'ups_second_day_air_am',
'ups_next_day_air',
'ups_next_day_air_saver',
'ups_next_day_air_early_am',
'ups_mail_innovations_domestic',
'ups_surepost',
'ups_surepost_bound_printed_matter',
'ups_surepost_lightweight',
'ups_surepost_media',
'ups_express',
'ups_express_1200',
'ups_express_plus',
'ups_expedited',
'ups_express_early',
'ups_access_point_economy',
'canada_post_regular_parcel',
'canada_post_expedited_parcel',
'canada_post_priority',
'canada_post_xpresspost',
'canada_post_xpresspost_international',
'canada_post_xpresspost_usa',
'canada_post_expedited_parcel_usa',
'canada_post_tracked_packet_usa',
'canada_post_small_packet_usa_air',
'canada_post_tracked_packet_international',
'canada_post_small_packet_international_air',
'dhl_express_domestic_express_doc',
'dhl_express_economy_select_doc',
'dhl_express_worldwide_nondoc',
'dhl_express_worldwide_doc',
'dhl_express_worldwide',
'dhl_express_worldwide_eu_doc',
'dhl_express_break_bulk_express_doc',
'dhl_express_express_9_00_nondoc',
'dhl_express_economy_select_nondoc',
'dhl_express_break_bulk_economy_doc',
'dhl_express_express_9_00_doc',
'dhl_express_express_10_30_doc',
'dhl_express_express_10_30_nondoc',
'dhl_express_express_12_00_doc',
'dhl_express_europack_nondoc',
'dhl_express_express_envelope_doc',
'dhl_express_express_12_00_nondoc',
'dhl_express_express_12_doc',
'dhl_express_worldwide_b2c_doc',
'dhl_express_worldwide_b2c_nondoc',
'dhl_express_medical_express',
'dhl_express_express_easy_nondoc',
'purolator_ground',
'purolator_express_international1200',
'purolator_ground_us',
'purolator_express',
'purolator_ground1030_am',
'purolator_express_international9_am',
'purolator_express_us1030_am',
'purolator_ground9_am',
'purolator_express_us',
'purolator_express9_am',
'purolator_express_international',
'purolator_express_us1200',
'purolator_express_us9_am',
'purolator_ground_distribution',
'purolator_express1030_am',
'purolator_ground_evening',
'purolator_express_evening',
'purolator_express_international1030_am'


]

const DEFAULT_PARCEL_FEES = {
  autoFill: true,
  parcelFeeDefaults:  [
		{size:"Small Envelope", fee:2.00},
		{size:"Small Box", fee:2.00},
		{size:"Medium Envelope", fee:5.00},
		{size:"Medium Box", fee:7.50},
		{size:"Large Envelope", fee:9.00},
		{size:"Large Box", fee:9.00}, 
		
	]
}

const getFileBase64 = (file, callback) => {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  // Since FileReader is asynchronous,
  // we need to pass data back.
  reader.onload = () => callback(reader.result);
  // TODO: catch an error
  reader.onerror = error => {};
};

const imageUploadCallback = file => new Promise(
  (resolve, reject) => getFileBase64(
    file,
    data => resolve({ data: { link: data } })
  )
);


class Venue extends Component {
  constructor(props) {
    super(props);
    const html = '<p>Hey this <strong>editor</strong> </p>';
    const contentBlock = htmlToDraft(html);
    var   editorState =EditorState.createEmpty();
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      editorState= EditorState.createWithContent(contentState);
      
    }
   
    this.state = {
      editorState:editorState,
      disabled: true,
      name: '',
      venueDescription: '',
      active: true,
      showAlert: false,
      publishId:'',
      error: '',
      billingAddress:'',
      shippingAddress:'',
      shippingAddress2:'',
      shippingCity:'',
      shippingState:'',
      shippingPostalCode:'',
      shippingCountry:'',
      address:'',
      id:'',
      imageURL : '',
      base64Icon:'',
      shippingPhone: '',
      mainPhone:'',
      hotelShippingFee:'',
      internationalShippingFee: '',
      shippingCarrier: '',
      shippingCarrierAccountNumber:'',
      shippingReturnLetter:'',
      shippingLabelOutput:'',
      isTestAccount: false,
      lostItemCounter: 0,
      labelPurchaseNotificationEmails: '',
      claimReportSMSPhoneNumbers:'',
      typeFormUrl:'',
      defaultPackingFee:0,
      shippingEmail:'',
      parcelFeeDefaults: JSON.stringify(DEFAULT_PARCEL_FEES),
      parcelFeeDefaultsObj:DEFAULT_PARCEL_FEES,
      claimNotificationStaffEmails:'',
      parcelReplyToEmail:'',
      displayParcelNotificationSettings: true,
      enableUnclaimMessage1:false,
      unclaimedMessage1:'',
      sendClaimUpdateAfterDays1:0,
      enableUnclaimMessage2:false,
      unclaimedMessage2:'',
      sendClaimUpdateAfterDays2:0,
      claimAutoArchiveInDays:0,
      enableClaimAutoArchive:false,
      enableEtip:false,
      eTipUrl:'',
      shippingConfiguration:{},
      selectedShippingRestrictions:[],
      itemFoundClaimMessage:'',
      aimProbabilityMatchMinimum:.85,
      notifyUnopenedShippingRequests:false,
      timeZone:'',
      shippingFeeLabel:'PACKAGING/SERVICE FEE',
      enableScheduleForPickupButton:false,
      enableRequestToShipButton:false,
      acceptParcelPayment:false,
      parcelReplyToAddresses:'',
      displayWillClaimOnInventoryTag:false,
      displayReleaseDateOnDashboard:false,
      claimItemNotFoundEmail:'',
      enabledPTUnreturnedEmails:false,
      ptScheduledUnretunredEmails:'',
      ptScheduledUnreturnedEmailTime:0,
      ptCheckinReport:false,
      ptCheckinReportDaysPrior:1,
      ptCheckinReportRecipientEmails:'',
      ptCheckinReportTimeOfDay:0,
      parcelPaymentTestMode:false,
      parcelPurchaseReplyToEmail:'',
    };
  }

  async componentDidMount() {
  
    axios.get(`${SERVER_URL}/venue/` + auth0Client.getActiveVenuedId(),{
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
    }).then((res)=>{
      const venue = res.data;
      const html = venue.shippingReturnLetter;
      const contentBlock = htmlToDraft(html);
      var   editorState =EditorState.createEmpty();
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        editorState= EditorState.createWithContent(contentState);
        
      }

     //console.log(venue)

      this.setState({
        editorState:editorState,
        name: venue.name,
        active:venue.active,
        publishId:venue.publishId,
        venueDescription:venue.venueDescription,
        shippingAddress: venue.shippingAddress,
        shippingAddress2: venue.shippingAddress2,
        shippingCity: venue.shippingCity,
        shippingState: venue.shippingState,
        shippingPostalCode: venue.shippingPostalCode,
        shippingCountry: venue.shippingCountry,
        shippingPhone: venue.shippingPhone,
        mainPhone:venue.mainPhone,
        base64Icon: venue.base64Icon,
        billingAddress: venue.billingAddress,
        hotelShippingFee:venue.hotelShippingFee,
        bounteShippingPct:venue.bounteShippingPct,
        internationalShippingFee: venue.internationalShippingFee,
        shipEmailMessage:venue.shipEmailMessage,
        claimEmailMessage:venue.claimEmailMessage,
        id: venue.id,
        disabled:false,
        shippingCarrier: venue.shippingCarrier,
        shippingCarrierAccountNumber:venue.shippingCarrierAccountNumber,
        shippingReturnLetter:venue.shippingReturnLetter,
        shippingLabelOutput:venue.shippingLabelOutput,
        isTestAccount : venue.isTestAccount,
        lostItemCounter: venue.lostItemCounter,
        labelPurchaseNotificationEmails:venue.labelPurchaseNotificationEmails,
        claimReportSMSPhoneNumbers:venue.claimReportSMSPhoneNumbers,
        typeFormUrl: venue.typeFormUrl,
        defaultPackingFee: venue.defaultPackingFee,
        shippingEmail: venue.shippingEmail,
        parcelFeeDefaults: (venue.parcelFeeDefaults && venue.parcelFeeDefaults!=='') ? venue.parcelFeeDefaults: JSON.stringify(DEFAULT_PARCEL_FEES),
        parcelFeeDefaultsObj: (venue.parcelFeeDefaults && venue.parcelFeeDefaults!=='') ? JSON.parse(venue.parcelFeeDefaults) : DEFAULT_PARCEL_FEES,
        claimNotificationStaffEmails:venue.claimNotificationStaffEmails,
        prodCarrierFedEx : (venue.prodCarrierFedEx),
        prodCarrierDHL: (venue.prodCarrierDHL),
        prodCarrierUPS:(venue.prodCarrierUPS),
        prodCarrierUSPS: (venue.prodCarrierUSPS),
        prodCarrierCanadaPost : (venue.prodCarrierCanadaPost),
        prodCarrierPurolator: (venue.prodCarrierPurolator),
        parcelTrackingEmails: venue.parcelTrackingEmails,
        parcelReplyToEmail: venue.parcelReplyToEmail,
        enableUnclaimMessage1:venue.enableUnclaimMessage1,
        unclaimedMessage1:venue.unclaimedMessage1,
        sendClaimUpdateAfterDays1:venue.sendClaimUpdateAfterDays1,
        enableUnclaimMessage2:venue.enableUnclaimMessage2,
        unclaimedMessage2:venue.unclaimedMessage2,
        sendClaimUpdateAfterDays2:venue.sendClaimUpdateAfterDays2,
        claimAutoArchiveInDays:venue.claimAutoArchiveInDays,
        enableClaimAutoArchive:venue.enableClaimAutoArchive,
        eTipUrl:venue.eTipUrl,
        enableEtip:venue.enableEtip,
        shippingConfiguration:venue.shippingConfiguration,
        selectedShippingRestrictions: (venue.shippingConfiguration) ? venue.shippingConfiguration.restrictedServiceLevelTokens : [],
        itemFoundClaimMessage:venue.itemFoundClaimMessage,
        aimProbabilityMatchMinimum: venue.aimProbabilityMatchMinimum,
        notifyUnopenedShippingRequests:venue.notifyUnopenedShippingRequests,
        timeZone:venue.timeZone,
        shippingFeeLabel:(venue.shippingFeeLabel) ? venue.shippingFeeLabel : 'PACKAGING/SERVICE FEE',
        acceptParcelPayment:false, //venue.acceptParcelPayment,
        enableScheduleForPickupButton: venue.enableScheduleForPickupButton ,
        enableRequestToShipButton: venue.enableRequestToShipButton, 
        parcelReplyToAddresses:venue.parcelReplyToAddresses,
        displayWillClaimOnInventoryTag:venue.displayWillClaimOnInventoryTag,
        displayReleaseDateOnDashboard:venue.displayReleaseDateOnDashboard,
        claimItemNotFoundEmail:venue.claimItemNotFoundEmail,
        disableAutoFillFinderInfo:venue.disableAutoFillFinderInfo,
        enabledPTUnreturnedEmails:venue.enabledPTUnreturnedEmails,
        ptScheduledUnretunredEmails:venue.ptScheduledUnretunredEmails,
        ptScheduledUnreturnedEmailTime:venue.ptScheduledUnreturnedEmailTime,
        ptCheckinReport:venue.ptCheckinReport,
        ptCheckinReportDaysPrior:venue.ptCheckinReportDaysPrior,
        ptCheckinReportRecipientEmails:venue.ptCheckinReportRecipientEmails,
        ptCheckinReportTimeOfDay:venue.ptCheckinReportTimeOfDay,
        parcelPaymentTestMode:venue.parcelPaymentTestMode,
        parcelPurchaseReplyToEmail:venue.parcelPurchaseReplyToEmail,
      });
    }).catch((e)=>{ 
      //console.log("error " + e)
      ToastStore.error("An error occured. Please try again. error: " + e.message);
    });

 /*
    const venue = (await axios.get('http://localhost:5000/venue/' + auth0Client.venueId,{
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
    })).data;

      console.log(venue);

       this.setState({
          name: venue.name,
          active:venue.active,
          publishId:venue.publishId,
          description:venue.description,
          shippingAddress: venue.shippingAddress,
          billingAddress: venue.billingAddress,
          id: venue.id,
        });
  
   */
    

    
    
    
  }


  handleInputChange=(event) =>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  onEditorStateChange= (editorState) => {
    this.setState({
      editorState,
    });
  };

  handleDismiss=()=> {
    this.setState({ showAlert: false });
  }


  async submit() {
    

      if (!this.validate()){
        return;
      }

      this.setState({
        disabled: true,
      });

      var htmlLetter= draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));
      let shippingConfig = this.state.shippingConfiguration;
      if (shippingConfig){
        shippingConfig.restrictedServiceLevelTokens = this.state.selectedShippingRestrictions
      }
      await axios.post(`${SERVER_URL}/venue/`, {
        id:this.state.id,
        name: this.state.name,
        venueDescription: this.state.venueDescription,
        shippingAddress:this.state.shippingAddress,
        shippingAddress2:this.state.shippingAddress2,
        shippingCity:this.state.shippingCity,
        shippingState:this.state.shippingState,
        shippingPostalCode:this.state.shippingPostalCode,
        shippingCountry:this.state.shippingCountry,
        bounteShippingPct:this.state.bounteShippingPct,
        hotelShippingFee:this.state.hotelShippingFee,
        internationalShippingFee:this.state.internationalShippingFee,
        billingAddress:this.state.billingAddress,
        shippingPhone: this.state.shippingPhone,
        mainPhone:this.state.mainPhone,
        active: this.state.active,
        base64Icon:this.state.base64Icon,
        shipEmailMessage:this.state.shipEmailMessage,
        claimEmailMessage:this.state.claimEmailMessage,
        shippingCarrier: this.state.shippingCarrier,
        shippingCarrierAccountNumber:this.state.shippingCarrierAccountNumber,
        shippingLabelOutput: this.state.shippingLabelOutput,
        shippingReturnLetter:htmlLetter,
        lostItemCounter:this.state.lostItemCounter,
        labelPurchaseNotificationEmails: this.state.labelPurchaseNotificationEmails,
        claimReportSMSPhoneNumbers:this.state.claimReportSMSPhoneNumbers,
        defaultPackingFee : this.state.defaultPackingFee,
        shippingEmail: this.state.shippingEmail,
        typeFormUrl:this.state.typeFormUrl,
        parcelFeeDefaults: JSON.stringify(this.state.parcelFeeDefaultsObj),
        claimNotificationStaffEmails:this.state.claimNotificationStaffEmails,
        prodCarrierFedEx : (this.state.prodCarrierFedEx),
        prodCarrierDHL: (this.state.prodCarrierDHL),
        prodCarrierUPS:(this.state.prodCarrierUPS),
        prodCarrierUSPS: (this.state.prodCarrierUSPS),
        prodCarrierCanadaPost : (this.state.prodCarrierCanadaPost),
        prodCarrierPurolator: (this.state.prodCarrierPurolator),
        parcelTrackingEmails:this.state.parcelTrackingEmails,
        parcelReplyToEmail:this.state.parcelReplyToEmail,
        enableUnclaimMessage1:this.state.enableUnclaimMessage1,
        unclaimedMessage1:this.state.unclaimedMessage1,
        sendClaimUpdateAfterDays1:this.state.sendClaimUpdateAfterDays1,
        enableUnclaimMessage2:this.state.enableUnclaimMessage2,
        unclaimedMessage2:this.state.unclaimedMessage2,
        sendClaimUpdateAfterDays2:this.state.sendClaimUpdateAfterDays2,
        claimAutoArchiveInDays:this.state.claimAutoArchiveInDays,
        enableClaimAutoArchive:this.state.enableClaimAutoArchive,
        eTipUrl:this.state.eTipUrl,
        enableEtip:this.state.enableEtip,
        shippingConfiguration:shippingConfig,
        itemFoundClaimMessage:this.state.itemFoundClaimMessage,
        aimProbabilityMatchMinimum: this.state.aimProbabilityMatchMinimum,
        notifyUnopenedShippingRequests:this.state.notifyUnopenedShippingRequests,
        timeZone:this.state.timeZone,
        shippingFeeLabel:this.state.shippingFeeLabel,
        //acceptParcelPayment:this.state.acceptParcelPayment,
        enableScheduleForPickupButton: this.state.enableScheduleForPickupButton ,
        enableRequestToShipButton: this.state.enableRequestToShipButton, 
        parcelReplyToAddresses:this.state.parcelReplyToAddresses,
        displayWillClaimOnInventoryTag:this.state.displayWillClaimOnInventoryTag,
        displayReleaseDateOnDashboard:this.state.displayReleaseDateOnDashboard,
        claimItemNotFoundEmail:this.state.claimItemNotFoundEmail,
        disableAutoFillFinderInfo:this.state.disableAutoFillFinderInfo,
        enabledPTUnreturnedEmails:this.state.enabledPTUnreturnedEmails,
        ptScheduledUnretunredEmails:this.state.ptScheduledUnretunredEmails,
        ptScheduledUnreturnedEmailTime:this.state.ptScheduledUnreturnedEmailTime,
        ptCheckinReport:this.state.ptCheckinReport,
        ptCheckinReportDaysPrior:this.state.ptCheckinReportDaysPrior,
        ptCheckinReportRecipientEmails:this.state.ptCheckinReportRecipientEmails,
        ptCheckinReportTimeOfDay:this.state.ptCheckinReportTimeOfDay,
        parcelPaymentTestMode:this.state.parcelPaymentTestMode,
        parcelPurchaseReplyToEmail:this.state.parcelPurchaseReplyToEmail,
    }, {
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
    })
    .then((res)=>{
        //this.props.history.push('/');
        // Show saved successful
       
          this.setState({
            showAlert:false,
            disabled: false,
            showSuccess: true,
  
           });
        ToastStore.success('Venue Saved Successfully!');
        

        
     
    })
    .catch ((e)=>{
        
        this.setState({
            showAlert:true,
            disabled: false,
            error:e,

        })
        // show error message if available
        ToastStore.error(this.state.error.response.data);
        
    })

  }


  validate=()=>{
     // all fields are required
    if (this.state.name ==='') {
    
      ToastStore.error("Name is required");
      return false;
    }
    if (this.state.shippingAddress ==='') {
    
      ToastStore.error("Shipping address is required");
      return false;
    }

    if (this.state.shippingCity ==='') {
    
      ToastStore.error("Shipping City is required");
      return false;
    }
    /*if (this.state.shippingState ==='') {
    
      ToastStore.error("Shipping State is required");
      return false;
    }*/
    
   // if (this.state.shippingPostalCode ==='') {
    
     // ToastStore.error("Shipping Postal Code is required");
    //  return false;
    //}
    if (this.state.billingAddress ==='') {
    
      ToastStore.error("Billing address is required");
      return false;
    }
    if (this.state.shippingPhone ==='') {
    
      ToastStore.error("Shipping phone is required");
      return false;
    }
    if (this.state.shippingCountry ==='') {
    
      ToastStore.error("Shipping country is required");
      return false;
    }

    if (this.state.shippingEmail ==='') {
    
      ToastStore.error("A 'Reply-to E-Mail address is required.");
      return false;
    }
    
    // Make sure there are no ';' in the email settings
    if (this.state.labelPurchaseNotificationEmails){
      if (this.state.labelPurchaseNotificationEmails.includes(';')){
        ToastStore.error("Shipping purchase email settings can not have ';'.  Use commas to separate multiple email address");
        return false;
      }
    }
    // Make sure there are no ';' in the email settings
    if (this.state.shippingEmail){
      if (this.state.shippingEmail.includes(';')){
        ToastStore.error("Shipping email settings can not have ';'.  Use commas to separate multiple email address");
        return false;
      }
    }
    // Make sure there are no ';' in the email settings
    if (this.state.claimNotificationStaffEmails){
      if (this.state.claimNotificationStaffEmails.includes(';')){
        ToastStore.error("Claim notification email settings can not have ';'.  Use commas to separate multiple email address");
        return false;
      }
    }

        
    
    return true;
  }

  renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}
onFileChange=(e)=>{
  let files= e.target.files;
  if (files.length ===1){
      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload=(e)=>{
        var data = e.target.result;
        //console.log(data);
        // upload the new file to the venue account
        this.setState({
          base64Icon:data,
        })
      }
  }

}
renderIframeInstructions=()=>{

  var iFrameString = '<iframe src=' + LOCAL_URL + '/PortalLostAndFound?portalKey='+ this.state.publishId + '&bgcolor=006a65 class="main" frameborder="0" height="900" width="100%" ></iframe>';
 return iFrameString;
}

renderTypeFormInstructions=()=>{
  var rtVal =  this.state.typeFormUrl;
  return rtVal;
}

handleFeeUpdate=(e, index)=>{
  
    let {parcelFeeDefaultsObj} =  this.state;
    //let formattedPRecision = (Math.round(parseFloat(e.target.value) * 100) / 100).toFixed(2);
    //console.log(formattedPRecision);
    parcelFeeDefaultsObj.parcelFeeDefaults[index].fee=parseFloat(e.target.value);
  
    this.setState({
      parcelFeeDefaultsObj:parcelFeeDefaultsObj
    })
 
}
formatFee=(feeVal)=>{
  if (feeVal){
     return (Math.round(parseFloat(feeVal) * 100) / 100).toFixed(2);
  }
}
renderFeeList=()=>{
  try{
      // For each item in venue's 
      if(this.state.parcelFeeDefaultsObj){
         
          return <>{this.state.parcelFeeDefaultsObj.parcelFeeDefaults.map((parcelFee, index) => {
           
              
              return(<li style={{fontSize:'11px' }} key={parcelFee.size}>
               
               
                <div className='row'>
                  <div className='col'>
                      <h6>{parcelFee.size}: </h6>
                  </div>
                  <div className='col-4'>
                  <input
                      disabled={this.state.disabled}
                      type="number"
                      onChange={(e)=>{
                        this.handleFeeUpdate(e, index)
                      }}
                      className="form-control"
                      placeholder=""
                      value = {parcelFee.fee}
                      name='feeScheduleItem'
                    />
                    </div>
                </div>
              
              
              </li>)
           
              
           })}</>
          
      }else{
        console.log('None Defined')
        return (null);
      }  

  }catch(e){
    console.log(e.message);
  }
  
  
}

  render() {
    const { editorState } = this.state;

    return (
      <div className="w-75 p-3">
      {this.renderToast()}

      <Tabs>
          <TabList>
            <Tab><p className='text-info'><b>General Settings</b></p></Tab>
            <Tab><p className='text-info'><b>Shipping Settings</b></p></Tab>
            <Tab><p className='text-info'><b>Shipping Carrier </b></p></Tab>
            <Tab><p className='text-info'><b>Shipping Form Letter</b></p></Tab>
            <Tab><p className='text-info'><b>Claims </b></p></Tab>
            <Tab><p className='text-info'><b>Billing </b></p></Tab>
           
            <Tab><p className='text-info'><b>Parcel Tracking</b></p></Tab>
            <Tab><p className='text-info'><b>3rd Party Settings</b></p></Tab>
            <Tab><p className='text-info'><b>UX Settings</b></p></Tab>
          </TabList>

          <TabPanel>
          <h5> Venue Settings</h5>
            <hr/>


          <div className="row">
          <div className="col-12">

                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className='text-primary'>Venue Name:</label>
                    <input
                      disabled={this.state.disabled}
                      type="text"
                      onChange={this.handleInputChange}
                      className="form-control"
                      placeholder="Give your venue a name."
                      value = {this.state.name}
                      name='name'
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className='text-primary'>Venue Description:</label>
                    <input
                      disabled={this.state.disabled}
                      type="text"
                      onChange={this.handleInputChange}
                      className="form-control"
                      placeholder="Please provide a description for the location."
                      value = {this.state.venueDescription}
                      name='venueDescription'
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="isTestAccount" className='text-primary'>{(this.state.isTestAccount) ? ' **** THIS IS A TEST ACCOUNT ****' : 'This is a Live Account'} </label>
                  
                  </div>


                  <div className="form-group">
                    <label htmlFor="mainPhone">Main Phone:</label>
                    <input
                      disabled={this.state.disabled}
                      type="text"
                      onChange={this.handleInputChange}
                      className="form-control"
                      placeholder=""
                      value = {this.state.mainPhone}
                      name='mainPhone'
                    />
                  </div>
                  <h6> Reply-To Email Address  </h6>
                    <div className="form-group">
                                  <label htmlFor="shippingEmail" className='text-primary'>This is the reply-to email(s) used for sending claim notifications and shipping label requests. Enter multiple emails (separate with commas ','):</label>
                                  <input
                                    disabled={this.state.disabled}
                                    type="text"
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    placeholder=""
                                    value = {this.state.shippingEmail}
                                    name='shippingEmail'
                                  />
                    </div>
                                <hr/>
                   <div className="form-group">
                    <label htmlFor="mainPhone">Start Lost Item ID # Counter At:</label>
                    <input
                      disabled={this.state.disabled}
                      type="numeric"
                      onChange={this.handleInputChange}
                      className="form-control"
                      placeholder=""
                      value = {this.state.lostItemCounter}
                      name='lostItemCounter'
                    />
                  </div>
                  <h6> Notification Of Claims and Found Items.  </h6>
                    <div className="form-group">
                                  <label htmlFor="claimReportSMSPhoneNumbers" className='text-primary'>Send text messages when claims are reported or items are found. Enter phone numbers (separate with commas ',') :</label>
                                  <input
                                    disabled={this.state.disabled}
                                    type="text"
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    placeholder="Add phone numbers  separate by ','"
                                    value = {this.state.claimReportSMSPhoneNumbers}
                                    name='claimReportSMSPhoneNumbers'
                                  />

                                                               
                    </div>
                    <h6> Notification Of New Claims:  Send an email to the following users:  </h6>
                    <div className="form-group">
                                  <label htmlFor="claimNotificationStaffEmails" className='text-primary'>Enter email addresses (separated with commas ','). This will be in addition any SMS settings above :</label>
                                  <input
                                    disabled={this.state.disabled}
                                    type="text"
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    placeholder="Add Email Addresses separate by ','"
                                    value = {this.state.claimNotificationStaffEmails}
                                    name='claimNotificationStaffEmails'
                                  />

                                <hr/>


                                
                    </div>
                    
                   <h6> Logo  </h6>
                   <p className='text-secondary'>Used for emails &amp; form letters </p>
                <input type="file" name='file' onChange={(e)=>this.onFileChange(e)} />
                
                <img style={{width: '125px', height:'75px'}} src={this.state.base64Icon} alt=''/> 
                
                <hr/>

                <h6> Personalized Message in Claim Emails: </h6>
                <p className="text-secondary">The BOUNTE system will auto-include the claim id, description of the item, and email link. Just provide the messaage content below: </p>
                                <textarea
                                                disabled={this.state.disabled}
                                              
                                                onChange={this.handleInputChange}
                                                name="claimEmailMessage"
                                                className="form-control"
                                                placeholder=""

                                                value= {this.state.claimEmailMessage}
                                  />   

                <br/>
                <h6> Timezone: </h6>
               
                <select
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="timeZone"
                                            className='custom-select'
                                            placeholder=""
                                            value= {this.state.timeZone}
                                          > 
                                          <option key="" value=""></option>
                                          {momenttz.tz.names().map(item => (
                                            <option key={item} value={item}>
                                              {item}
                                            </option>
                                          ))}
                </select>

                </div>
               

                </div>
              

          </TabPanel>
          <TabPanel>
          <h5> Shipping Information </h5>
            <hr/>

          <div className="form-row">
                                <div className="col">
                                <label htmlFor="exampleInputEmail1" className='text-primary'>Address:</label>
                                                <input
                                                disabled={this.state.disabled}
                                                type="text"
                                                name="shippingAddress"
                                                onChange={this.handleInputChange}
                                                className="form-control"
                                                placeholder="required"
                                                value= {this.state.shippingAddress}
                                                />
                                </div>
                                </div>
                                <div className="form-row">
                                <div className="col">
                                <label htmlFor="exampleInputEmail1" className='text-primary'>Address2 :</label>
                                                <input
                                                disabled={this.state.disabled}
                                                type="text"
                                                name="shippingAddress2"
                                                onChange={this.handleInputChange}
                                                className="form-control"
                                                placeholder=""
                                                value= {this.state.shippingAddress2}
                                                />
                                </div>
                        </div>
                        <div className='form-row'>
                                            <div className='col'>
                                                <label htmlFor="shippingCity" className='text-primary'> City:</label>
                                              <input
                                                disabled={this.state.disabled}
                                                type="text"
                                                onChange={this.handleInputChange}
                                                name="shippingCity"
                                                className="form-control"
                                                placeholder=""
                                                value= {this.state.shippingCity}
                                              />    

                                            </div>
                            </div>
                            <div className='form-row'>
                                            <div className='col'>
                                            <label htmlFor="shippingState" className='text-primary'> State :</label>
                                            <input
                                                disabled={this.state.disabled}
                                                type="text"
                                                onChange={this.handleInputChange}
                                                name="shippingState"
                                                className="form-control"
                                                placeholder=""

                                                value= {this.state.shippingState}
                                              />   
                                             
                                             
                                            
                                            </div>
                                            <div className='col-4'>
                                                <label htmlFor="shippingPostalCode" className='text-primary'> Postal Code :</label>
                                              <input
                                                disabled={this.state.disabled}
                                                type="text"
                                                onChange={this.handleInputChange}
                                                name="shippingPostalCode"
                                                className="form-control"
                                                placeholder=""

                                                value= {this.state.shippingPostalCode}
                                              />   

                                            </div>
                              </div>
  
                                        <label htmlFor="shippingCountry" className='text-primary'> Country :</label>
                                          <select
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="shippingCountry"
                                            className='custom-select'
                                            placeholder=""
                                            value= {this.state.shippingCountry}
                                          > 
                                          {isoCountries.map(item => (
                                            <option key={item.ccode} value={item.ccode}>
                                              {item.cname}
                                            </option>
                                          ))}
                                </select>   
                                
                                <div className="form-group">
                                  <label htmlFor="shippingPhone" className='text-primary'>Shipping Phone (required):</label>
                                  <input
                                    disabled={this.state.disabled}
                                    type="text"
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    placeholder="Please provide a shipping phone numer.  This is required for many of the carriers."
                                    value = {this.state.shippingPhone}
                                    name='shippingPhone'
                                  />
                                </div>

                                <div className="form-group">
                                  <label htmlFor="labelPurchaseNotificationEmails" className='text-primary'>Label Purchase Notification: Enter the email(s) for BOUNTE to notify upon shipment purchase (separate each with a comma):</label>
                                  <input
                                    disabled={this.state.disabled}
                                    type="text"
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    placeholder="Add email addresses separate by ','"
                                    value = {this.state.labelPurchaseNotificationEmails}
                                    name='labelPurchaseNotificationEmails'
                                  />

                                <hr/>

                                <h6> Personalized Message in Shipment Emails: </h6>
                                <p className="text-secondary">The BOUNTE system will auto-include the item id, description of the found item, and email link. Just provide the messaage content below: </p>
 
                                <textarea
                                                disabled={this.state.disabled}
                                               
                                                onChange={this.handleInputChange}
                                                name="shipEmailMessage"
                                                className="form-control"
                                                placeholder=""

                                                value= {this.state.shipEmailMessage}
                                  />   



                                  </div>

                                  <br/>

                                        <label htmlFor="shippingLabelOutput" className='text-primary'> Label Output Format :</label>
                                          <select
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="shippingLabelOutput"
                                            className='custom-select'
                                            placeholder=""
                                            value= {this.state.shippingLabelOutput}
                                          > 
                                         
                                            <option key='8X11' value='PDF'>8.5" X 11"</option>
                                            <option key='PDF_4x6' value='PDF_4x6'>Label Writer (Thermal): 4" X 6"</option>
                                          </select>   

                                          
                                  <br/>

                                  <label htmlFor="shippingFeeLabel" className='text-primary'> Shipping Fee Line Item Label (This is the line item on the carrier rates page):</label>      
                                  <input
                                                disabled={this.state.disabled}
                                               
                                                onChange={this.handleInputChange}
                                                name="shippingFeeLabel"
                                                className="form-control"
                                                placeholder=""

                                                value= {this.state.shippingFeeLabel}
                                  /> 
                    
                    <div>
                      <br/>
                      <div className='form-row'>
                          <div className='col'>
                            <h6>Auto-Resend Shipping Request</h6>
                            <p className="text-secondary text-left">Check to enable BOUNTE to resend any shipping emails that have not been opened for over 24 hours.  Sometimes they go to spam or are forgotten. </p>

                          </div>
                      </div>
                      <div className='form-row'>
                          <div className='col-12'>
                          <input
                            disabled={this.state.disabled}
                            type="checkbox"
                            onChange={this.handleInputChange}
                            className="text-center"
                            placeholder=""
                            checked = {this.state.notifyUnopenedShippingRequests}
                            name='notifyUnopenedShippingRequests'
                            style={{fontSize:14, width:20, height:20, marginRight:10}}
                          />    
                        <label htmlFor="notifyUnopenedShippingRequests" className='text-primary'>ENABLED</label>

                          </div>
                         
 
                        
                      </div>
                    
                      
                                        

                    
                    </div>

          </TabPanel>
          <TabPanel>
          <h5>Shipping Carrier Settings </h5>
           
           <hr/>
               
           
           <br/>
           <p className="text-primary">Check the shipping carrier(s) available for this account.  Your customers will only see selected carrier options.</p>

           <br/> <br/> 
            

                    <div className='form-row'>
                      <div className='col'>
                        <div className="form-check">

                          <input
                            disabled={this.state.disabled}
                            type="checkbox"
                            onChange={this.handleInputChange}
                            className="form-check-input"
                            placeholder=""
                            checked = {this.state.prodCarrierFedEx}
                            name='prodCarrierFedEx'
                            style={{fontSize:14, width:20, height:20, marginRight:15}}
                          />
                        
                          <img src='./images/fedex_logo.jpeg'  alt="fedex" width='80px' height='50px'/>
                       </div>
                      </div>
                      <div className='col'>
                        <div className="form-check">

                          <input
                            disabled={this.state.disabled}
                            type="checkbox"
                            onChange={this.handleInputChange}
                            className="form-check-input"
                            placeholder=""
                            checked = {this.state.prodCarrierUSPS}
                            name='prodCarrierUSPS'
                            style={{fontSize:14, width:20, height:20, marginRight:15}}
                          />
                          
                          <img src='./images/usps_logo.png' alt="usps" width='90px' height='80px'/>
                       </div>
                      </div>
                      <div className='col'>
                        <div className="form-check">

                          <input
                            disabled={this.state.disabled}
                            type="checkbox"
                            onChange={this.handleInputChange}
                            className="form-check-input"
                            placeholder=""
                            checked = {this.state.prodCarrierUPS}
                            name='prodCarrierUPS'
                            style={{fontSize:14, width:20, height:20, marginRight:15}}
                          />
                         
                          <img src='./images/ups_logo.png' alt="ups" width='80px' height='50px'/>
                       </div>
                      </div>
                      <div className='col'>
                        <div className="form-check">

                          <input
                            disabled={this.state.disabled}
                            type="checkbox"
                            onChange={this.handleInputChange}
                            className="form-check-input"
                            placeholder=""
                            checked = {this.state.prodCarrierDHL}
                            name='prodCarrierDHL'
                            style={{fontSize:14, width:20, height:20, marginRight:15}}
                          />
                       &nbsp;
                          <img src='./images/DHL_logo.png' alt="dhl" width='80px' height='50px'/>
                       </div>
                      </div>
                      <div className='col'>
                        <div className="form-check">

                          <input
                            disabled={this.state.disabled}
                            type="checkbox"
                            onChange={this.handleInputChange}
                            className="form-check-input"
                            placeholder=""
                            checked = {this.state.prodCarrierCanadaPost}
                            name='prodCarrierCanadaPost'
                            style={{fontSize:14, width:20, height:20, marginRight:15}}
                          />
                       &nbsp;
                          <img src='./images/canada_post_logo.png' alt="dhl" width='90px' height='60px'/>
                       </div>
                      </div>
                      <div className='col'>
                        <div className="form-check">

                          <input
                            disabled={this.state.disabled}
                            type="checkbox"
                            onChange={this.handleInputChange}
                            className="form-check-input"
                            placeholder=""
                            checked = {this.state.prodCarrierPurolator}
                            name='prodCarrierPurolator'
                            style={{fontSize:14, width:20, height:20, marginRight:15}}
                          />
                       &nbsp;
                          <img src='./images/purolator-logo-vector.png' alt="dhl" width='90px' height='80px'/>
                       </div>
                      </div>

                   </div>
            <hr/>
           
            <div className='row'>
                <div className='col text-info text-center'><h6>Restrict The Following Shipping Options:</h6></div> 
                
            </div>
          
            <div className='row'>      
                <div className='col text-center'  style={{backgroundColor:'white'}}>

                              
              <Multiselect
                    ref={this.multiselectCategoriesRef}
                    showArrow={true}
                    isObject={false}
                    //displayValue='name'
                    options={restrictedTokens} // Options to display in the dropdown
                    selectedValues={this.state.selectedShippingRestrictions} // Preselected value to persist in dropdown
                    onSelect={(selectedList, selectedItem) =>{
                      //console.log(selectedList);
                      this.setState({selectedShippingRestrictions:selectedList})
                    }} // Function will trigger on select event
                    onRemove={(selectedList, removedItem)=>{
                     // console.log(selectedList);
                      this.setState({selectedShippingRestrictions:selectedList})
                    }} // Function will trigger on remove event
                    style={{
                      chips: {
                      
                        fontSize: '1.2sem',
                        color:'white',
                        fontWeight:'bold'
                      },
                      multiselectContainer: {
                        color: 'black',
                        fontWeight:'bold'
                      },
                     
                    }}
              /></div>
           
            </div>


          </TabPanel>



          <TabPanel>
              <h5>Form Letter Settings :</h5>
              <p className='text-primary'>Edit the form letter to print when returning items </p>
              <p className='text-primary'>Note: Use "[firstName]" and "[lastName]" tags to have BOUNTE auto-fill them when printing. Note: Use Shift + Enter for linebreaks </p>
             
              <Editor
                  className="form-control"
                  toolbarClassName="demo-toolbar-custom"
                  editorState={editorState}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  onEditorStateChange={this.onEditorStateChange}
                  toolbar={{
                    inline: { inDropdown: true },
                    list: { inDropdown: true },
                    textAlign: { inDropdown: true },
                    link: { inDropdown: true },
                    history: { inDropdown: true },
                    image: { uploadCallback: imageUploadCallback,  previewImage: true, alt: { present: true, mandatory: true } },
                  }}
                
                />

                <hr/>
                  <p className='text-secondary'>Form letters are printed with 8.5" X 11" paper size </p>

              <hr/>
             
                
            </TabPanel>



            <TabPanel>
              <h5>Claim Settings:</h5>
              <p className='text-primary'></p>
              <hr/>
              <div className="card border-info mb-3" >
                  <div className="card-header"><h3>Claim Scheduled Automatic Notifications: </h3><br/>
                  <p className="text-primary" style={{fontSize:'16px'}}>BOUNTE can send automatic claim updates with a personalized message after a specific number of days.  If the claim has not been matched with a found item, BOUNTE will send the following message(s).</p>
                  </div>
                  <div className="card-body">
                      <h6 >Message #1 Settings: </h6>
                        <div className="row" style={{marginLeft:10}}>
                       
                          <input
                            disabled={this.state.disabled}
                            type="checkbox"
                            onChange={this.handleInputChange}
                            className="form-check-input"
                            checked = {this.state.enableUnclaimMessage1}
                            name='enableUnclaimMessage1'
                            style={{fontSize:14, width:20,height:20}}
                          />
                          <p className="text-primary" style={{marginLeft:10}}>Enabled</p>
                          </div>
                         
                  
                          <div className="row" >
                              <div className="col-9">
                                  <p className="text-primary" style={{fontSize:'14px'}}>Edit the custom message to send to guests when the claim is not found:</p>
                                  <textarea
                                    disabled={this.state.disabled}
                                    rows={2}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    style={{backgroundColor:'white'}}
                                    value = {this.state.unclaimedMessage1}
                                    name='unclaimedMessage1'
                                />
                            
                              </div>
                              <div className="col-3">
                              <p className="text-primary" style={{fontSize:'14px'}}>Auto-send this message after:</p>

                                    <select
                                            disabled={this.state.disabled}
                                            type="text"
                                            style={{fontSize:14, width:200, }}
                                            onChange={this.handleInputChange}
                                            name="sendClaimUpdateAfterDays1"
                                            className='custom-select'
                                            placeholder=""
                                            value= {this.state.sendClaimUpdateAfterDays1}
                                          > 
                                          <option key='' value=""></option>
                                          <option key='1' value="1">1 Days</option>
                                          <option key='2' value="2">2 Days</option>
                                          <option key='3' value="3">3 Days</option>
                                          <option key='5' value="5">5 Days</option>
                                            <option key='7' value="7">7 Days</option>
                                             <option key='15' value="15">15 Days</option>
                                            <option key='30' value="30">30 Days</option>
                                            <option key='45' value="45">45 Days</option>
                                            <option key='60' value="60">60 Days</option>
                                            <option key='90' value="90">90 Days</option>
                                              
                                         
                                </select>   
                              </div>
                          </div>
                      <br/><hr/>
                          <h6 >Message #2 Settings: </h6>
                        <div className="row" style={{marginLeft:10}}>
                       
                       
                       <input
                         disabled={this.state.disabled}
                         type="checkbox"
                         onChange={this.handleInputChange}
                         className="form-check-input"
                         checked = {this.state.enableUnclaimMessage2}
                         name='enableUnclaimMessage2'
                         style={{fontSize:14, width:20,height:20}}
                       />
                       <p className="text-primary" style={{marginLeft:10}}>Enabled</p>
                       </div>
                         
                  
                          <div className="row" >
                              <div className="col-9">
                                  <p className="text-primary" style={{fontSize:'14px'}}>Edit the custom message to send to guests when the claim is not found:</p>
                                  <textarea
                                    disabled={this.state.disabled}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    style={{backgroundColor:'white'}}
                                    value = {this.state.unclaimedMessage2}
                                    name='unclaimedMessage2'
                                />
                            
                              </div>
                              <div className="col-3">
                              <p className="text-primary" style={{fontSize:'14px'}}>Auto-send this message after:</p>

                                    <select
                                            disabled={this.state.disabled}
                                            type="text"
                                            style={{fontSize:14, width:200, }}
                                            onChange={this.handleInputChange}
                                            name="sendClaimUpdateAfterDays2"
                                            className='custom-select'
                                            placeholder=""
                                            value= {this.state.sendClaimUpdateAfterDays2}
                                          > 
                                          <option key='' value=""></option>
                                          <option key='1' value="1">1 Days</option>
                                          <option key='2' value="2">2 Days</option>
                                          <option key='3' value="3">3 Days</option>
                                          <option key='5' value="5">5 Days</option>
                                         <option key='7' value="7">7 Days</option>
                                         <option key='15' value="15">15 Days</option>
                                          <option key='30' value="30">30 Days</option>
                                          <option key='45' value="45">45 Days</option>
                                          <option key='60' value="60">60 Days</option>
                                          <option key='90' value="90">90 Days</option>
                                            
                                         
                                </select>   
                              </div>
                          </div>
                   
                  

                  <br/><hr/>
                 <h6 >Auto-archive Open Claim Settings: </h6>
                  <div className="row" style={{marginLeft:10}}>
                       
                        <div className="col-3">
                              <input
                                disabled={this.state.disabled}
                                type="checkbox"
                                onChange={this.handleInputChange}
                                className="form-check-input"
                                checked = {this.state.enableClaimAutoArchive}
                                name='enableClaimAutoArchive'
                                style={{fontSize:14, width:20,height:20}}
                              />
                                <p className="text-primary" style={{marginLeft:10}}>Enabled</p>
                      </div>
                       <div className="col-9">
                       <select
                                            disabled={this.state.disabled}
                                            type="text"
                                            style={{fontSize:14, width:200, }}
                                            onChange={this.handleInputChange}
                                            name="claimAutoArchiveInDays"
                                            className='custom-select'
                                            placeholder=""
                                            value= {this.state.claimAutoArchiveInDays}
                                          > 
                                         
                                         <option key='7' value="7">7 Days</option>
                                         <option key='15' value="15">15 Days</option>
                                            <option key='30' value="30">30 Days</option>
                                            <option key='45' value="45">45 Days</option>
                                            <option key='60' value="60">60 Days</option>
                                            <option key='90' value="90">90 Days</option>
                              </select>                
                                         
                      </div>
                </div>
                </div>
                </div>
              <div className="card border-info mb-3" >
                  <div className="card-header"><h3>Claim Flow Settings: </h3><br/>
                 Use the following URL to add Claim Flow to your website.  Change the  "/to/" to "/c/" for conversasion UI.
                  </div>
                  <div className="card-body">
                    <h6 className="card-title">URL:</h6>
                    <p className="text-info" style={{fontSize:'14px'}}>

                    <input
                    disabled={this.state.disabled}
                    style={{backgroundColor:'white'}}
                    onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="0.00"
                    value = {this.state.typeFormUrl}
                    name='typeFormUrl'
                  />
                    
                    </p>
                      
                  
                   
                  </div>

                 
                </div>
                <br/>
                <div className="card border-info mb-3 col-12" >
                  <div className="card-header "><h3>Found Item Email Settings: </h3><br/>
                    Enter a custom message for the found item email:
                  </div>
                  <div className="card-body">
                    <h6 className="card-title">Message:</h6>
                    <p className="text-info" style={{fontSize:'14px'}}>

                          <textarea
                          disabled={this.state.disabled}
                          style={{backgroundColor:'white'}}
                          onChange={this.handleInputChange}
                          className="form-control"
                          placeholder=""
                          value = {this.state.itemFoundClaimMessage}
                          name='itemFoundClaimMessage' 
                        />
                    
                    </p>
                    <br/>
                  
                    <h6> Include these actions in the email: </h6>
                        <div className="row" style={{marginLeft:10}}>
                        <div className="col-3">
                              <input
                                disabled={this.state.disabled}
                                type="checkbox"
                                onChange={this.handleInputChange}
                                className="form-check-input"
                                checked = {this.state.enableRequestToShipButton}
                                name='enableRequestToShipButton'
                                style={{fontSize:14, width:20,height:20}}
                              />
                                <p className="text-primary" style={{marginLeft:10}}>Enable Request To Ship Button</p>
                      </div>
                      <div className="col-3">
                              <input
                                disabled={this.state.disabled}
                                type="checkbox"
                                onChange={this.handleInputChange}
                                className="form-check-input"
                                checked = {this.state.enableScheduleForPickupButton}
                                name='enableScheduleForPickupButton'
                                style={{fontSize:14, width:20,height:20}}
                              />
                                <p className="text-primary" style={{marginLeft:10}}>Enable Request To Pick-Up Button</p>
                      </div>

                        </div>
                   
                  </div>

                 
                </div>

                <div className="card border-info mb-3 col-4" >
                  <div className="card-header "><h3>Item Not Found Email: </h3><br/>
                    This is the email sent to the guest when the item is not found.  Enter a custom message for the email:
                  </div>
                  <div className="card-body">
                    <h6 className="card-title">Message:</h6>
                    <p className="text-info" style={{fontSize:'14px'}}>

                    <textarea
                    disabled={this.state.disabled}
                    style={{backgroundColor:'white'}}
                    onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="leave blank for default message"
                    value = {this.state.claimItemNotFoundEmail}
                    name='claimItemNotFoundEmail' 
                  />
                    
                    </p>
                      
                  
                   
                  </div>

                 
                </div>

                <div className="card border-info mb-3 col-4" >
                  <div className="card-header "><h3>AIM Settings: </h3><br/>
                    Minimum Probability for matched (0-1).  Choose a higher number for higher-volume matching. Average is .85
                  </div>
                  <div className="card-body">
                    <h6 className="card-title">Probability:</h6>
                    <p className="text-info" style={{fontSize:'14px'}}>

                    <input
                    disabled={this.state.disabled}
                    style={{backgroundColor:'white'}}
                    onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="0.00"
                    value = {this.state.aimProbabilityMatchMinimum}
                    name='aimProbabilityMatchMinimum' 
                  />
                    
                    </p>
                      
                  
                   
                  </div>

                 
                </div>
              
            </TabPanel>


          <TabPanel>
          <div className="form-group">
                  <h5>Venue Billing Address:</h5>
                  <hr/>
                  <input
                    disabled={this.state.disabled}
                    type="text"
                    onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="Please provide a billing address for the location."
                    value = {this.state.billingAddress}
                    name='billingAddress'
                  />
                </div>
                <div className="form-check">
                  
                  <input
                    disabled={this.state.disabled}
                    type="checkbox"
                    onChange={this.handleInputChange}
                    className="form-check-input"
                    placeholder=""
                    checked = {this.state.active}
                    name='active'
                  />
                  <label htmlFor="exampleInputEmail1" className='text-primary'>Active : Check to make active.  Uncheck to deactivate adding items to this location. </label>
                  <br/> <br/>

                  <hr/>
              
              <h5> Shipping &amp; Fee Settings: Use your shipping address currency </h5>
              <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className='text-primary'><b>Shipping Fee</b> (Local Currency):</label>
                  <input
                    disabled={this.state.disabled}
                    type="number"
                    onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="$0.00"
                    value = {this.state.hotelShippingFee}
                    name='hotelShippingFee'
                  />
                </div>
                <div className="form-group">
                <label htmlFor="exampleInputEmail1" className='text-primary'><b>Int'l Shipping Fee </b> (Local Currency):</label>
                  <input
                    disabled={this.state.disabled}
                    type="number"
                    onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="$0.00"
                    value = {this.state.internationalShippingFee}
                    name='internationalShippingFee'
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className='text-primary'>Bounte %:</label>
                  <input
                    disabled={this.state.disabled}
                    type="number"
                    onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="0.00%"
                    value = {this.state.bounteShippingPct}
                    name='bounteShippingPct'
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="defaultPackingFee" className='text-primary'>Default Packaging Fee (Local Currency):</label>
                  <br/><p style={{fontSize:11}}>Choosing "Own Packaging" from the shipping parcel options in the shipping wizard will auto-fill this amount</p>
                  <input
                    disabled={this.state.disabled}
                    type="number"
                    onChange={this.handleInputChange}
                    className="form-control"
                    placeholder="0.00"
                    value = {this.state.defaultPackingFee}
                    name='defaultPackingFee'
                  />
                </div>
                

                </div>

          </TabPanel>

       
          <TabPanel>
          <h3>Parcel Tracking Settings: </h3>
          <br/>
          <p className = 'text-primary'>
            The fee schedule below applies to the handing fees for handling packages received.  Note:  These are not the fees specified when requesting postage purchases.  Those are set in the billing tab. 
          </p>
     
                <br/><br/>
           <div className='row'>
             <div className='col-6'>
                  <div className="card border-info mb-3" >
                    <div className="card-header"><h5>Parcel Tracking Fee Defaults:</h5> <br/>
                      <p className = 'text-primary'>Enter the fees for each type of package size.  These will default as the appropriate package size selection is made in the Parcel Editor.
                      </p>
                        </div>
                        <div className="card-body">
                          <h6 className="card-title">Fees:</h6>

                            <ul>
                                {this.renderFeeList()}
                            </ul>
                        
                    </div>

                </div>
                <br/>
                <div className="card border-info mb-3" >
                    <div className="card-header"><h5>Enable Pre-arrival Parcel Report</h5> <br/>
                      <p className = 'text-primary'>Scheduled report listing parcels for registered guests 1-day prior to check-in.  Enter the staff email addresses to send the email to.
                      </p>
                        </div>
                        <div className="card-body">
                        
                          <div className='form-row'>
                              <div className='col-1'>
                              <input
                                                disabled={this.state.disabled}
                                                type="checkbox"
                                                onChange={this.handleInputChange}
                                                className="form-check-input"
                                                placeholder=""
                                                checked = {this.state.ptCheckinReport}
                                                name='ptCheckinReport'
                                                style={{fontSize:14, width:20, height:20, marginLeft:10}}
                                                title='Enable email notifications for unreturned parcels'
                                              />

                              </div>
                              <div className='col-11 text-left'>
                              <p className="text-primary">Enable report</p>
                              </div>
                            </div>

                         
                           
                             <br/>
                          <h6 className="card-title">Emails: Enter multiple staff email addresses separated by a ','</h6>
                          
                          <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              className="form-control"
                              placeholder="Enter Emails separated by ','"
                              value = {this.state.ptCheckinReportRecipientEmails}
                              name='ptCheckinReportRecipientEmails'
                          />
                          <br/>
                           <h6 className="card-title">Select the time to run the report:</h6>
                           <select 
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              className="form-control"
                              value = {this.state.ptCheckinReportTimeOfDay}
                              name='ptCheckinReportTimeOfDay'>
                              <option value='0'>12:00 AM</option>
                              <option value='1'>1:00 AM</option>
                              <option value='2'>2:00 AM</option>
                              <option value='3'>3:00 AM</option>
                              <option value='4'>4:00 AM</option>
                              <option value='5'>5:00 AM</option>
                              <option value='6'>6:00 AM</option>
                              <option value='7'>7:00 AM</option>
                              <option value='8'>8:00 AM</option>
                              <option value='9'>9:00 AM</option>
                              <option value='10'>10:00 AM</option>
                              <option value='11'>11:00 AM</option>
                              <option value='12'>12:00 PM</option>
                              <option value='13'>1:00 PM</option>
                              <option value='14'>2:00 PM</option>
                              <option value='15'>3:00 PM</option>
                              <option value='16'>4:00 PM</option>
                              <option value='17'>5:00 PM</option>
                              <option value='18'>6:00 PM</option>
                              <option value='19'>7:00 PM</option>
                              <option value='20'>8:00 PM</option>
                              <option value='21'>9:00 PM</option>
                              <option value='22'>10:00 PM</option>
                              <option value='23'>11:00 PM</option>
                               
                              </select>
                    </div>
                    
                </div>
                <br/>

                <div className="card border-info mb-3" >
                    <div className="card-header"><h5>Parcel Tracking Test Mode</h5> <br/>
                      <p className = 'text-primary'>Test the new parcel tracking feature to request payment from guests
                      </p>
                        </div>
                        <div className="card-body">
                        
                          <div className='form-row'>
                              <div className='col-1'>
                            
                              <input
                                                disabled={this.state.disabled}
                                                type="checkbox"
                                                onChange={this.handleInputChange}
                                                className="form-check-input"
                                                placeholder=""
                                                checked = {this.state.parcelPaymentTestMode}
                                                name='parcelPaymentTestMode'
                                                style={{fontSize:14, width:20, height:20, marginLeft:10}}
                                                title='Enable email notifications for unreturned parcels'
                                              />
                            
                              </div>
                              <div className='col-11 text-left'>
                              <p className="text-primary">Enable Parcel Tracking Test Mode</p>
                              </div>
                            </div>


                           
                             <br/>
                          
                    </div>
                    
                </div>
                <br/>
               
                <div className="card-body">
                          <h6 className="card-title">Send an email to these addresses when parcel fees are paid (comma-separated):</h6>

                          <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              className="form-control"
                              placeholder="Enter Emails separated by ','"
                              value = {this.state.parcelPurchaseReplyToEmail}
                              name='parcelPurchaseReplyToEmail'
                          />
                </div>


             </div>
            
           {this.state.displayParcelNotificationSettings && <div className='col-6'>
                  <div className="card border-info mb-3" >
                    <div className="card-header"><h5>Staff &amp; Department Emails:</h5> <br/>
                      <p className = 'text-primary'>Enter multiple email addresses separated by a ','. These are emails in addition to Users' emails that can be selected for notification when parcel(s) arrive.  
                      </p>
                        </div>
                        <div className="card-body">
                          <h6 className="card-title">Emails:</h6>

                          <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              className="form-control"
                              placeholder="Enter Emails separated by ','"
                              value = {this.state.parcelTrackingEmails}
                              name='parcelTrackingEmails'
                          />
                        
                    </div>
                    
                </div>
                <br/>
                <div className="card-body">
                          <h6 className="card-title">When sending parcel received notifications, use this reply-to address(s):</h6>

                          <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              className="form-control"
                              placeholder="Enter Emails separated by ','"
                              value = {this.state.parcelReplyToEmail}
                              name='parcelReplyToEmail'
                          />
                </div>
                <br/>
                <div className="card border-info mb-3" >
                    <div className="card-header"><h5>Undelivered guest parcel email to staff:</h5> <br/>
                      <p className = 'text-primary'>Parcels for registered guest that are unreturned 24 hours prior to departure will trigger an email to the staff.  Enter the email addresses to send the email to.
                      </p>
                        </div>
                        <div className="card-body">
                        
                          <div className='form-row'>
                              <div className='col-1'>
                              <input
                                                disabled={this.state.disabled}
                                                type="checkbox"
                                                onChange={this.handleInputChange}
                                                className="form-check-input"
                                                placeholder=""
                                                checked = {this.state.enabledPTUnreturnedEmails}
                                                name='enabledPTUnreturnedEmails'
                                                style={{fontSize:14, width:20, height:20, marginLeft:10}}
                                                title='Enable email notifications for unreturned parcels'
                                              />

                              </div>
                              <div className='col-11 text-left'>
                              <p className="text-primary">Enable email notifications for unreturned parcels</p>
                              </div>
                            </div>

                         
                           
                             <br/>
                          <h6 className="card-title">Emails: Enter multiple email addresses separated by a ','</h6>
                          
                          <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              className="form-control"
                              placeholder="Enter Emails separated by ','"
                              value = {this.state.ptScheduledUnretunredEmails}
                              name='ptScheduledUnretunredEmails'
                          />
                          <br/>
                           <h6 className="card-title">Select the hour each day this report should run:</h6>
                           <select 
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              className="form-control"
                              value = {this.state.ptScheduledUnreturnedEmailTime}
                              name='ptScheduledUnreturnedEmailTime'>
                              <option value='0'>12:00 AM</option>
                              <option value='1'>1:00 AM</option>
                              <option value='2'>2:00 AM</option>
                              <option value='3'>3:00 AM</option>
                              <option value='4'>4:00 AM</option>
                              <option value='5'>5:00 AM</option>
                              <option value='6'>6:00 AM</option>
                              <option value='7'>7:00 AM</option>
                              <option value='8'>8:00 AM</option>
                              <option value='9'>9:00 AM</option>
                              <option value='10'>10:00 AM</option>
                              <option value='11'>11:00 AM</option>
                              <option value='12'>12:00 PM</option>
                              <option value='13'>1:00 PM</option>
                              <option value='14'>2:00 PM</option>
                              <option value='15'>3:00 PM</option>
                              <option value='16'>4:00 PM</option>
                              <option value='17'>5:00 PM</option>
                              <option value='18'>6:00 PM</option>
                              <option value='19'>7:00 PM</option>
                              <option value='20'>8:00 PM</option>
                              <option value='21'>9:00 PM</option>
                              <option value='22'>10:00 PM</option>
                              <option value='23'>11:00 PM</option>
                               
                              </select>
                    </div>
                    
                </div>

             </div>
          }
           </div>    
           {
                              this.state.acceptParcelPayment &&  <div className='row'>
             <div className='col-6'>
                <div className="card border-info mb-3" >
                            <div className="card-body">

                                <h6 className="card-title">Parcel Payment Management</h6>
                                
                                <div className='form-row'>
                                      <div className='col-1'>
                                            <div className="form-check">

                                              <input
                                                disabled={this.state.disabled}
                                                type="checkbox"
                                                onChange={this.handleInputChange}
                                                className="form-check-input"
                                                placeholder=""
                                                checked = {this.state.acceptParcelPayment}
                                                name='acceptParcelPayment'
                                                style={{fontSize:14, width:20, height:20, marginRight:15}}
                                              />
                                                      
                                          </div>
                                        </div>
                                        <div className='col-11'>
                                        <p className="text-primary"> Enable your account to send payment requests and accept payment for parcels returned.</p>
                                        </div>
                                  </div>
                                  <br/><br/>
                          <div className='form-row'>
                              <div className='col-12'>
                              <h6>When sending parcel payment requests, use these email addresses for the reply-to.  </h6>
                                  <div className="form-group">
                                                <label htmlFor="parcelReplyToAddresses" className='text-primary'> Enter multiple emails (separate with commas ','):</label>
                                                <input
                                                  disabled={this.state.disabled}
                                                  type="text"
                                                  onChange={this.handleInputChange}
                                                  className="form-control"
                                                  placeholder=""
                                                  value = {this.state.parcelReplyToAddresses}
                                                  name='parcelReplyToAddresses'
                                                />
                                  </div>
                                  </div>
                            </div>
                          
                               
                              </div>

                             </div>

                </div>
           </div>
    }
               
          </TabPanel>

          <TabPanel>
                      
          <h3>3rd Party and Integration settings</h3>
          <br/>
          <p className = 'text-primary'>Update the settings for the applicable service(s).  Contact support@bounte.net for requests. </p>
           
          <hr/>

         
                      <div className='form-row'>
                      <div className='col-1'>
                                <div className="form-check">

                                  <input
                                    disabled={this.state.disabled}
                                    type="checkbox"
                                    onChange={this.handleInputChange}
                                    className="form-check-input"
                                    placeholder=""
                                    checked = {this.state.enableEtip}
                                    name='enableEtip'
                                    style={{fontSize:14, width:20, height:20, marginRight:15}}
                                  />
                                           
                              </div>
                            </div>
                          <div className='col-1'>
                                <img style={{width: '120px', height:'40px'}} src='../../images/etip.png' alt='eTip Partner'></img>
                          </div>
                          <div className='col-4'>
                              <p className="text-primary"> Enable the eTip.io provider. Adds a "Tip Now" button to the shipping receipt &amp; tracking emails.  ** An eTip account is required. </p>
                          </div>
                        
                            <div className='col-5'>
                            <h6 className="card-title">eTip Account URL:</h6>

                                    <input
                                        disabled={!this.state.enableEtip}
                                        type="text"
                                        onChange={this.handleInputChange}
                                        className="form-control"
                                        placeholder=""
                                        value = {this.state.eTipUrl}
                                        name='eTipUrl'
                                    />
                            </div>
                      </div>
          </TabPanel>

          <TabPanel>

          <h5>UX Settings :</h5>
          <br/>
          <p className = 'text-primary'>General settings for the user experience. </p>
          <hr/>
          <div className='form-row'>
                      <div className='col-1'>
                                <div className="form-check">

                                  <input
                                    disabled={this.state.disabled}
                                    type="checkbox"
                                    onChange={this.handleInputChange}
                                    className="form-check-input"
                                    placeholder=""
                                    checked = {this.state.displayReleaseDateOnDashboard}
                                    name='displayReleaseDateOnDashboard'
                                    style={{fontSize:14, width:20, height:20, marginRight:15}}
                                  />
                                           
                              </div>
                            </div>
                        
                          <div className='col-4'>
                              <p className="text-primary"> Display a list of found items on the Dashboard by Release Date</p>
                          </div>
                        
                            <div className='col-1'>
                           
                              <div className="form-check">
                                      <input
                                          disabled={this.state.disabled}
                                          type="checkbox"
                                          onChange={this.handleInputChange}
                                          className="form-check-input"
                                          placeholder=""
                                          checked = {this.state.displayWillClaimOnInventoryTag}
                                          name='displayWillClaimOnInventoryTag'
                                          style={{fontSize:14, width:20, height:20, marginRight:15}}
                                      />
                                </div>
                            </div>
                            <div className='col-4'>
                              <p className="text-primary"> Display a 'Will Claim' notification on inventory tags</p>
                          </div>

                         
                          

                      </div>
                      <div className='form-row'>
                      <div className='col-1'>
                           
                           <div className="form-check">
                                   <input
                                       disabled={this.state.disabled}
                                       type="checkbox"
                                       onChange={this.handleInputChange}
                                       className="form-check-input"
                                       placeholder=""
                                       checked = {this.state.disableAutoFillFinderInfo}
                                       name='disableAutoFillFinderInfo'
                                       style={{fontSize:14, width:20, height:20, marginRight:15}}
                                   />
                             </div>
                         </div>
                         <div className='col-4'>
                           <p className="text-primary">Do Not Auto-fill finder when creating a new found item record (webapp only)</p>
                       </div>
                      
                      </div>
          </TabPanel>
    
        </Tabs>
        <hr/>
        <br/><br/><br/><br/><br/>

        <div className="row">
          <div className="col-12">
            

                <button
                  disabled={this.state.disabled}
                  className="btn btn-primary"
                  onClick={() => {this.submit()}}>
                  Update
                </button>
              
          </div>
        </div>
       </div>
      
    )
  }
}

export default withRouter(Venue);


const isoCountries = [
  {'ccode' : 'US', 'cname' : 'United States'},
  {'ccode' : 'AF', 'cname' : 'Afghanistan'},
  {'ccode' : 'AX', 'cname' : 'Aland Islands'},
  {'ccode' : 'AL', 'cname' : 'Albania'},
  {'ccode' : 'DZ', 'cname' : 'Algeria'},
  {'ccode' : 'AS', 'cname' : 'American Samoa'},
  {'ccode' : 'AD', 'cname' : 'Andorra'},
  {'ccode' : 'AO', 'cname' : 'Angola'},
  {'ccode' : 'AI', 'cname' : 'Anguilla'},
  {'ccode' : 'AQ', 'cname' : 'Antarctica'},
  {'ccode' : 'AG', 'cname' : 'Antigua And Barbuda'},
  {'ccode' : 'AR', 'cname' : 'Argentina'},
  {'ccode' : 'AM', 'cname' : 'Armenia'},
  {'ccode' : 'AW', 'cname' : 'Aruba'},
  {'ccode' : 'AU', 'cname' : 'Australia'},
  {'ccode' : 'AT', 'cname' : 'Austria'},
  {'ccode' : 'AZ', 'cname' : 'Azerbaijan'},
  {'ccode' : 'BS', 'cname' : 'Bahamas'},
  {'ccode' : 'BH', 'cname' : 'Bahrain'},
  {'ccode' : 'BD', 'cname' : 'Bangladesh'},
  {'ccode' : 'BB', 'cname' : 'Barbados'},
  {'ccode' : 'BY', 'cname' : 'Belarus'},
  {'ccode' : 'BE', 'cname' : 'Belgium'},
  {'ccode' : 'BZ', 'cname' : 'Belize'},
  {'ccode' : 'BJ', 'cname' : 'Benin'},
  {'ccode' : 'BM', 'cname' : 'Bermuda'},
  {'ccode' : 'BT', 'cname' : 'Bhutan'},
  {'ccode' : 'BO', 'cname' : 'Bolivia'},
  {'ccode' : 'BA', 'cname' : 'Bosnia And Herzegovina'},
  {'ccode' : 'BW', 'cname' : 'Botswana'},
  {'ccode' : 'BV', 'cname' : 'Bouvet Island'},
  {'ccode' : 'BR', 'cname' : 'Brazil'},
  {'ccode' : 'IO', 'cname' : 'British Indian Ocean Territory'},
  {'ccode' : 'BN', 'cname' : 'Brunei Darussalam'},
  {'ccode' : 'BG', 'cname' : 'Bulgaria'},
  {'ccode' : 'BF', 'cname' : 'Burkina Faso'},
  {'ccode' : 'BI', 'cname' : 'Burundi'},
  {'ccode' : 'KH', 'cname' : 'Cambodia'},
  {'ccode' : 'CM', 'cname' : 'Cameroon'},
  {'ccode' : 'CA', 'cname' : 'Canada'},
  {'ccode' : 'CV', 'cname' : 'Cape Verde'},
  {'ccode' : 'KY', 'cname' : 'Cayman Islands'},
  {'ccode' : 'CF', 'cname' : 'Central African Republic'},
  {'ccode' : 'TD', 'cname' : 'Chad'},
  {'ccode' : 'CL', 'cname' : 'Chile'},
  {'ccode' : 'CN', 'cname' : 'China'},
  {'ccode' : 'CX', 'cname' : 'Christmas Island'},
  {'ccode' : 'CC', 'cname' : 'Cocos (Keeling) Islands'},
  {'ccode' : 'CO', 'cname' : 'Colombia'},
  {'ccode' : 'KM', 'cname' : 'Comoros'},
  {'ccode' : 'CG', 'cname' : 'Congo'},
  {'ccode' : 'CD', 'cname' : 'Congo, Democratic Republic'},
  {'ccode' : 'CK', 'cname' : 'Cook Islands'},
  {'ccode' : 'CR', 'cname' : 'Costa Rica'},
  {'ccode' : 'CI', 'cname' : 'Cote D\'Ivoire'},
  {'ccode' : 'HR', 'cname' : 'Croatia'},
  {'ccode' : 'CU', 'cname' : 'Cuba'},
  {'ccode' : 'CY', 'cname' : 'Cyprus'},
  {'ccode' : 'CZ', 'cname' : 'Czech Republic'},
  {'ccode' : 'DK', 'cname' : 'Denmark'},
  {'ccode' : 'DJ', 'cname' : 'Djibouti'},
  {'ccode' : 'DM', 'cname' : 'Dominica'},
  {'ccode' : 'DO', 'cname' : 'Dominican Republic'},
  {'ccode' : 'EC', 'cname' : 'Ecuador'},
  {'ccode' : 'EG', 'cname' : 'Egypt'},
  {'ccode' : 'SV', 'cname' : 'El Salvador'},
  {'ccode' : 'GQ', 'cname' : 'Equatorial Guinea'},
  {'ccode' : 'ER', 'cname' : 'Eritrea'},
  {'ccode' : 'EE', 'cname' : 'Estonia'},
  {'ccode' : 'ET', 'cname' : 'Ethiopia'},
  {'ccode' : 'FK', 'cname' : 'Falkland Islands (Malvinas)'},
  {'ccode' : 'FO', 'cname' : 'Faroe Islands'},
  {'ccode' : 'FJ', 'cname' : 'Fiji'},
  {'ccode' : 'FI', 'cname' : 'Finland'},
  {'ccode' : 'FR', 'cname' : 'France'},
  {'ccode' : 'GF', 'cname' : 'French Guiana'},
  {'ccode' : 'PF', 'cname' : 'French Polynesia'},
  {'ccode' : 'TF', 'cname' : 'French Southern Territories'},
  {'ccode' : 'GA', 'cname' : 'Gabon'},
  {'ccode' : 'GM', 'cname' : 'Gambia'},
  {'ccode' : 'GE', 'cname' : 'Georgia'},
  {'ccode' : 'DE', 'cname' : 'Germany'},
  {'ccode' : 'GH', 'cname' : 'Ghana'},
  {'ccode' : 'GI', 'cname' : 'Gibraltar'},
  {'ccode' : 'GR', 'cname' : 'Greece'},
  {'ccode' : 'GL', 'cname' : 'Greenland'},
  {'ccode' : 'GD', 'cname' : 'Grenada'},
  {'ccode' : 'GP', 'cname' : 'Guadeloupe'},
  {'ccode' : 'GU', 'cname' : 'Guam'},
  {'ccode' : 'GT', 'cname' : 'Guatemala'},
  {'ccode' : 'GG', 'cname' : 'Guernsey'},
  {'ccode' : 'GN', 'cname' : 'Guinea'},
  {'ccode' : 'GW', 'cname' : 'Guinea-Bissau'},
  {'ccode' : 'GY', 'cname' : 'Guyana'},
  {'ccode' : 'HT', 'cname' : 'Haiti'},
  {'ccode' : 'HM', 'cname' : 'Heard Island & Mcdonald Islands'},
  {'ccode' : 'VA', 'cname' : 'Holy See (Vatican City State)'},
  {'ccode' : 'HN', 'cname' : 'Honduras'},
  {'ccode' : 'HK', 'cname' : 'Hong Kong'},
  {'ccode' : 'HU', 'cname' : 'Hungary'},
  {'ccode' : 'IS', 'cname' : 'Iceland'},
  {'ccode' : 'IN', 'cname' : 'India'},
  {'ccode' : 'ID', 'cname' : 'Indonesia'},
  {'ccode' : 'IR', 'cname' : 'Iran, Islamic Republic Of'},
  {'ccode' : 'IQ', 'cname' : 'Iraq'},
  {'ccode' : 'IE', 'cname' : 'Ireland'},
  {'ccode' : 'IM', 'cname' : 'Isle Of Man'},
  {'ccode' : 'IL', 'cname' : 'Israel'},
  {'ccode' : 'IT', 'cname' : 'Italy'},
  {'ccode' : 'JM', 'cname' : 'Jamaica'},
  {'ccode' : 'JP', 'cname' : 'Japan'},
  {'ccode' : 'JE', 'cname' : 'Jersey'},
  {'ccode' : 'JO', 'cname' : 'Jordan'},
  {'ccode' : 'KZ', 'cname' : 'Kazakhstan'},
  {'ccode' : 'KE', 'cname' : 'Kenya'},
  {'ccode' : 'KI', 'cname' : 'Kiribati'},
  {'ccode' : 'KR', 'cname' : 'Korea'},
  {'ccode' : 'KW', 'cname' : 'Kuwait'},
  {'ccode' : 'KG', 'cname' : 'Kyrgyzstan'},
  {'ccode' : 'LA', 'cname' : 'Lao People\'s Democratic Republic'},
  {'ccode' : 'LV', 'cname' : 'Latvia'},
  {'ccode' : 'LB', 'cname' : 'Lebanon'},
  {'ccode' : 'LS', 'cname' : 'Lesotho'},
  {'ccode' : 'LR', 'cname' : 'Liberia'},
  {'ccode' : 'LY', 'cname' : 'Libyan Arab Jamahiriya'},
  {'ccode' : 'LI', 'cname' : 'Liechtenstein'},
  {'ccode' : 'LT', 'cname' : 'Lithuania'},
  {'ccode' : 'LU', 'cname' : 'Luxembourg'},
  {'ccode' : 'MO', 'cname' : 'Macao'},
  {'ccode' : 'MK', 'cname' : 'Macedonia'},
  {'ccode' : 'MG', 'cname' : 'Madagascar'},
  {'ccode' : 'MW', 'cname' : 'Malawi'},
  {'ccode' : 'MY', 'cname' : 'Malaysia'},
  {'ccode' : 'MV', 'cname' : 'Maldives'},
  {'ccode' : 'ML', 'cname' : 'Mali'},
  {'ccode' : 'MT', 'cname' : 'Malta'},
  {'ccode' : 'MH', 'cname' : 'Marshall Islands'},
  {'ccode' : 'MQ', 'cname' : 'Martinique'},
  {'ccode' : 'MR', 'cname' : 'Mauritania'},
  {'ccode' : 'MU', 'cname' : 'Mauritius'},
  {'ccode' : 'YT', 'cname' : 'Mayotte'},
  {'ccode' : 'MX', 'cname' : 'Mexico'},
  {'ccode' : 'FM', 'cname' : 'Micronesia, Federated States Of'},
  {'ccode' : 'MD', 'cname' : 'Moldova'},
  {'ccode' : 'MC', 'cname' : 'Monaco'},
  {'ccode' : 'MN', 'cname' : 'Mongolia'},
  {'ccode' : 'ME', 'cname' : 'Montenegro'},
  {'ccode' : 'MS', 'cname' : 'Montserrat'},
  {'ccode' : 'MA', 'cname' : 'Morocco'},
  {'ccode' : 'MZ', 'cname' : 'Mozambique'},
  {'ccode' : 'MM', 'cname' : 'Myanmar'},
  {'ccode' : 'NA', 'cname' : 'Namibia'},
  {'ccode' : 'NR', 'cname' : 'Nauru'},
  {'ccode' : 'NP', 'cname' : 'Nepal'},
  {'ccode' : 'NL', 'cname' : 'Netherlands'},
  {'ccode' : 'AN', 'cname' : 'Netherlands Antilles'},
  {'ccode' : 'NC', 'cname' : 'New Caledonia'},
  {'ccode' : 'NZ', 'cname' : 'New Zealand'},
  {'ccode' : 'NI', 'cname' : 'Nicaragua'},
  {'ccode' : 'NE', 'cname' : 'Niger'},
  {'ccode' : 'NG', 'cname' : 'Nigeria'},
  {'ccode' : 'NU', 'cname' : 'Niue'},
  {'ccode' : 'NF', 'cname' : 'Norfolk Island'},
  {'ccode' : 'MP', 'cname' : 'Northern Mariana Islands'},
  {'ccode' : 'NO', 'cname' : 'Norway'},
  {'ccode' : 'OM', 'cname' : 'Oman'},
  {'ccode' : 'PK', 'cname' : 'Pakistan'},
  {'ccode' : 'PW', 'cname' : 'Palau'},
  {'ccode' : 'PS', 'cname' : 'Palestinian Territory, Occupied'},
  {'ccode' : 'PA', 'cname' : 'Panama'},
  {'ccode' : 'PG', 'cname' : 'Papua New Guinea'},
  {'ccode' : 'PY', 'cname' : 'Paraguay'},
  {'ccode' : 'PE', 'cname' : 'Peru'},
  {'ccode' : 'PH', 'cname' : 'Philippines'},
  {'ccode' : 'PN', 'cname' : 'Pitcairn'},
  {'ccode' : 'PL', 'cname' : 'Poland'},
  {'ccode' : 'PT', 'cname' : 'Portugal'},
  {'ccode' : 'PR', 'cname' : 'Puerto Rico'},
  {'ccode' : 'QA', 'cname' : 'Qatar'},
  {'ccode' : 'RE', 'cname' : 'Reunion'},
  {'ccode' : 'RO', 'cname' : 'Romania'},
  {'ccode' : 'RU', 'cname' : 'Russian Federation'},
  {'ccode' : 'RW', 'cname' : 'Rwanda'},
  {'ccode' : 'BL', 'cname' : 'Saint Barthelemy'},
  {'ccode' : 'SH', 'cname' : 'Saint Helena'},
  {'ccode' : 'KN', 'cname' : 'Saint Kitts And Nevis'},
  {'ccode' : 'LC', 'cname' : 'Saint Lucia'},
  {'ccode' : 'MF', 'cname' : 'Saint Martin'},
  {'ccode' : 'PM', 'cname' : 'Saint Pierre And Miquelon'},
  {'ccode' : 'VC', 'cname' : 'Saint Vincent And Grenadines'},
  {'ccode' : 'WS', 'cname' : 'Samoa'},
  {'ccode' : 'SM', 'cname' : 'San Marino'},
  {'ccode' : 'ST', 'cname' : 'Sao Tome And Principe'},
  {'ccode' : 'SA', 'cname' : 'Saudi Arabia'},
  {'ccode' : 'SN', 'cname' : 'Senegal'},
  {'ccode' : 'RS', 'cname' : 'Serbia'},
  {'ccode' : 'SC', 'cname' : 'Seychelles'},
  {'ccode' : 'SL', 'cname' : 'Sierra Leone'},
  {'ccode' : 'SG', 'cname' : 'Singapore'},
  {'ccode' : 'SK', 'cname' : 'Slovakia'},
  {'ccode' : 'SI', 'cname' : 'Slovenia'},
  {'ccode' : 'SB', 'cname' : 'Solomon Islands'},
  {'ccode' : 'SO', 'cname' : 'Somalia'},
  {'ccode' : 'ZA', 'cname' : 'South Africa'},
  {'ccode' : 'GS', 'cname' : 'South Georgia And Sandwich Isl.'},
  {'ccode' : 'ES', 'cname' : 'Spain'},
  {'ccode' : 'LK', 'cname' : 'Sri Lanka'},
  {'ccode' : 'SD', 'cname' : 'Sudan'},
  {'ccode' : 'SR', 'cname' : 'Suriname'},
  {'ccode' : 'SJ', 'cname' : 'Svalbard And Jan Mayen'},
  {'ccode' : 'SZ', 'cname' : 'Swaziland'},
  {'ccode' : 'SE', 'cname' : 'Sweden'},
  {'ccode' : 'CH', 'cname' : 'Switzerland'},
  {'ccode' : 'SY', 'cname' : 'Syrian Arab Republic'},
  {'ccode' : 'TW', 'cname' : 'Taiwan'},
  {'ccode' : 'TJ', 'cname' : 'Tajikistan'},
  {'ccode' : 'TZ', 'cname' : 'Tanzania'},
  {'ccode' : 'TH', 'cname' : 'Thailand'},
  {'ccode' : 'TL', 'cname' : 'Timor-Leste'},
  {'ccode' : 'TG', 'cname' : 'Togo'},
  {'ccode' : 'TK', 'cname' : 'Tokelau'},
  {'ccode' : 'TO', 'cname' : 'Tonga'},
  {'ccode' : 'TT', 'cname' : 'Trinidad And Tobago'},
  {'ccode' : 'TN', 'cname' : 'Tunisia'},
  {'ccode' : 'TR', 'cname' : 'Turkey'},
  {'ccode' : 'TM', 'cname' : 'Turkmenistan'},
  {'ccode' : 'TC', 'cname' : 'Turks And Caicos Islands'},
  {'ccode' : 'TV', 'cname' : 'Tuvalu'},
  {'ccode' : 'UG', 'cname' : 'Uganda'},
  {'ccode' : 'UA', 'cname' : 'Ukraine'},
  {'ccode' : 'AE', 'cname' : 'United Arab Emirates'},
  {'ccode' : 'GB', 'cname' : 'United Kingdom'},
 
  {'ccode' : 'UM', 'cname' : 'United States Outlying Islands'},
  {'ccode' : 'UY', 'cname' : 'Uruguay'},
  {'ccode' : 'UZ', 'cname' : 'Uzbekistan'},
  {'ccode' : 'VU', 'cname' : 'Vanuatu'},
  {'ccode' : 'VE', 'cname' : 'Venezuela'},
  {'ccode' : 'VN', 'cname' : 'Viet Nam'},
  {'ccode' : 'VG', 'cname' : 'Virgin Islands, British'},
  {'ccode' : 'VI', 'cname' : 'Virgin Islands, U.S.'},
  {'ccode' : 'WF', 'cname' : 'Wallis And Futuna'},
  {'ccode' : 'EH', 'cname' : 'Western Sahara'},
  {'ccode' : 'YE', 'cname' : 'Yemen'},
  {'ccode' : 'ZM', 'cname' : 'Zambia'},
  {'ccode' : 'ZW', 'cname' : 'Zimbabwe'}
];
